// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host ::ng-deep .p-dialog {
  max-width: 90vw;
  width: 450px; /* Updated width */
  background-color: white;
}

:host ::ng-deep .p-dialog .p-dialog-content {
  padding: 1rem; /* Updated padding */
}

.options {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
}

:host ::ng-deep .option-card {
  cursor: pointer;
  text-align: center;
  transition: all 0.3s ease;
}

:host ::ng-deep .option-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

:host ::ng-deep .option-card .p-card-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 160px; /* Updated height */
}

:host ::ng-deep .option-card i {
  font-size: 3rem;
  margin-bottom: 1rem;
  color: #007bff;
}

:host ::ng-deep .option-card h3 {
  margin-bottom: 0.5rem;
}

:host ::ng-deep .option-card p {
  margin-bottom: 0;
}

@media screen and (max-width: 640px) {
  .options {
    grid-template-columns: 1fr;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/dialogs/createapp/create.app.dialog.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,YAAY,EAAE,kBAAkB;EAChC,uBAAuB;AACzB;;AAEA;EACE,aAAa,EAAE,oBAAoB;AACrC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa,EAAE,mBAAmB;AACpC;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[":host ::ng-deep .p-dialog {\n  max-width: 90vw;\n  width: 450px; /* Updated width */\n  background-color: white;\n}\n\n:host ::ng-deep .p-dialog .p-dialog-content {\n  padding: 1rem; /* Updated padding */\n}\n\n.options {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1rem;\n}\n\n:host ::ng-deep .option-card {\n  cursor: pointer;\n  text-align: center;\n  transition: all 0.3s ease;\n}\n\n:host ::ng-deep .option-card:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n:host ::ng-deep .option-card .p-card-body {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 160px; /* Updated height */\n}\n\n:host ::ng-deep .option-card i {\n  font-size: 3rem;\n  margin-bottom: 1rem;\n  color: #007bff;\n}\n\n:host ::ng-deep .option-card h3 {\n  margin-bottom: 0.5rem;\n}\n\n:host ::ng-deep .option-card p {\n  margin-bottom: 0;\n}\n\n@media screen and (max-width: 640px) {\n  .options {\n    grid-template-columns: 1fr;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
